import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import { resizeParent } from '../../services/Utils'

// Components
import Spinner from '../Spinner';
import SelectMenu from '../SelectMenu';
import SearchInput from '../SearchInput';
import DefaultCard from '../Cards/DefaultCard';
import { Series } from './Series';
import moment from 'moment'

// Styles
import styles from './Podcasting.css';

// Redux
import { configure, getConfiguration } from '../../actions/Settings'
import { getEpisodes } from '../../actions/Podcasting';

export const TCCPodcasting = ({ site, display, theme, series, showfilters, searchlabel, categorylabel, speakerlabel, type, limit }) => {

    // Default State
    const dispatch = useDispatch();
    const [containerClassName, setContainerClassName] = useState('loading')
    const [searchString, setSearchString] = useState('');
    const [speaker, setSpeaker] = useState('');
    const [category, setCategory] = useState('');
    const [view, setView] = useState(display);

    const [episodeList, setEpisodeList] = useState([]);
    const [speakerList, setSpeakerList] = useState([]);
    const [seriesList, setSeriesList] = useState([]);

    // Store
    const fullSettings = useSelector(state => state.Settings)
    const fullPodcasting = useSelector(state => state.Podcasting);

    // Default Labels
    searchlabel = (searchlabel) ? searchlabel : 'Search';
    categorylabel = (categorylabel) ? categorylabel : 'Series';
    speakerlabel = (speakerlabel) ? speakerlabel : 'Speaker';

    // ----------------------------
    // Effects
    // ----------------------------

    // On Mount
    useEffect(() => {

        // Configure
        dispatch(configure(site))

        // Load Configuration
        dispatch(getConfiguration());

        // Get Podcasts
        dispatch(getEpisodes(series, type, limit));

    }, [])

    useEffect(() => {

        if (!fullPodcasting.ui) return;
        if (fullPodcasting.ui === "loading") return;


        // Update The Episode List
        const filteredEpisodes = fullPodcasting.podcast.episodes.filter(episode => {

            // Filter By Speaker
            if (speaker && speaker != "all" && !episode.people[speaker]) return;


            // Filter By Series
            if (category && category != "all" && !episode.series[category]) return;

            // Found
            return episode;
        })

        // Set List
        setEpisodeList(filteredEpisodes);


    }, [searchString, speaker, category])

    // Episodes changed
    useEffect(() => {

        // resize the parent for embeds
        resizeParent();
        if (!fullPodcasting.ui) return;
        if (fullPodcasting.ui === "loading") return;

        // Get List of Speakers
        setSpeakerList(fullPodcasting.podcast.speakers);

        // Get List of series
        setSeriesList(fullPodcasting.podcast.series);

        // Set Full Episode List
        setEpisodeList(fullPodcasting.podcast.episodes);

    }, [fullPodcasting])

    const handleSeriesClick = (selectedSeries) => {



        // Set The Filter Series to
        setCategory(selectedSeries);
        setView('feed')

        // Scroll to Top
        const selector = '[data-component-type="TCCPodcasting"]';
        const element = document.querySelector(selector);
        element.scrollIntoView(true);
    }

    const handleBackClick = (e) => {
        e.preventDefault();
        setView('series');
    }
    // ----------------------------
    // Format Data
    // ----------------------------

    let speakers = [];
    let categories = [];

    if (type !== 'pco') {
        speakers = speakerList.map(speaker => { return { id: speaker.term_id, title: speaker.name, value: speaker.term_id } });
        categories = seriesList.map(series => { return { id: series.term_id, title: series.name, value: series.id } });
    }


    // ----------------------------
    // Render
    // ----------------------------

    // Loading Toggle
    const renderBody = () => {

        // Guard: Not loaded
        if (fullPodcasting.ui === 'loading') return (<div className="loading"><Spinner /></div>);

        if (!view || view === 'feed') return (<div className="posts-loop">{renderCards()}</div>);

        if (view === 'series') return (<div className="posts-loop">{renderSeries()}</div>);


    }

    // Render Cards
    const renderCards = () => {

        return episodeList.map(item => {
            // Set Excerpt to be the post date
            if (!item.excerpt) item.excerpt = moment(item.date).format('MMMM D, YYYY');
            // Invalid Date
            if (item.excerpt && (item.excerpt.toLowerCase().indexOf('invalid date') > -1)) {
                item.excerpt = item.date;
            }

            // Render
            return (
                <DefaultCard {...item} key={item.id} />
            )
        })

    }

    // Render Series
    const renderSeries = () => {

        return seriesList.map(item => {

            // Don't Render The Series that is Set.
            if (series && item.id === parseInt(series)) return false;

            return (
                <Series {...item} key={item.id} onClick={handleSeriesClick} />
            )
        })
    }

    // Selected Series
    const renderSelectedSeriesControls = () => {
        const series = seriesList.filter(item => item.id === category)[0]
        return (
            <div className="NavigationBar">
                <a href="#" onClick={handleBackClick}>Back To Series</a>
                <b dangerouslySetInnerHTML={{ __html: series.name }} />
                <span>&nbsp;</span>
            </div>
        )
    }

    // Render Filters
    const renderControls = () => {
        if (!showfilters) return (<div></div>)
        if (fullPodcasting.ui === 'loading') return (<div></div>)
        if (display === 'series' && view === 'feed') return renderSelectedSeriesControls();
        else if (view === 'series') return (<div></div>)
        else if (type === 'pco') return (<div></div>)

        return (
            <div className="NavigationBar">

                <SelectMenu name="category" allowAll={true} title={categorylabel} onChange={(e) => setCategory(e.target.value)} options={categories} />

                <SelectMenu name="speaker" allowAll={true} title={speakerlabel} onChange={(e) => setSpeaker(e.target.value)} options={speakers} />

            </div>
        )
    }

    // Main

    return (
        <div className={containerClassName}>

            {renderControls()}

            <div className="card-feed">

                {renderBody()}

            </div>

        </div>
    )
}